// extracted by mini-css-extract-plugin
export var body = "_3c-1";
export var bodyPadded = "_3c-2";
export var chevron = "_3c-4";
export var chevronOpen = "_3c-5";
export var header = "_3c-0";
export var icon = "_3c-3";